export default __webpack_public_path__ + "media/zurb/img/lab/playground/grid-paper/grid-paper-83b6425000308b1d83234b110919e6e7.jpg";